import { Link } from "react-router-dom";
import { CalendarCheck } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const ConsultPromo = ({ chartContext = false, stacked = false, testid = "consult-promo" }) => {
  const { t } = useLang();
  return (
    <section className={`card-sacred-red p-8 ${stacked ? "sm:p-10 h-full flex items-center" : "sm:p-12"} relative overflow-hidden`} data-testid={testid}>
      <div className="absolute -right-24 -top-24 w-72 h-72 glow-red pointer-events-none" />
      <div className={`grid gap-8 items-center relative ${stacked ? "" : "lg:grid-cols-12"}`}>
        <div className={stacked ? "" : "lg:col-span-9"}>
          {chartContext && <p className="eyebrow mb-4">{t("promo.chart")}</p>}
          <h2 className="text-2xl sm:text-3xl gold-text mb-4">{t("promo.title")}</h2>
          <p className="text-slate-300 leading-relaxed font-serif-soft text-lg">{t("promo.text")}</p>
        </div>
        <div className={stacked ? "flex" : "lg:col-span-3 flex lg:justify-end"}>
          <Link to="/book" className="btn-gold px-7 py-3.5 flex items-center gap-2 whitespace-nowrap" data-testid={`${testid}-book-button`}>
            <CalendarCheck size={18} /> {t("promo.cta")}
          </Link>
        </div>
      </div>
    </section>
  );
};
